import React from 'react';

type Props = {
  title: string;
};

export const StaticPage: React.FC<Props> = ({ title, children }) => (
  <div className="bg-white">
    <div className="max-w-6xl mx-auto px-4 md:px-10 py-6 md:py-10 font-body">
      <article className="prose lg:prose-lg max-w-full">
        <h1 className="font-display uppercase">{title}</h1>

        {children}
      </article>
    </div>
  </div>
);
